export default {
  'upload-files': 'Subir archivos',
  'assign-products': 'Asignar inspector',
  'edit-products': 'Editar'
};
